import { render, staticRenderFns } from "./leadsStats.vue?vue&type=template&id=325a0bda&"
import script from "./leadsStats.vue?vue&type=script&lang=js&"
export * from "./leadsStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports